import React, { useState } from 'react';
import { FaInfo } from 'react-icons/fa';
import { usePopperTooltip, PopperOptions, Config } from 'react-popper-tooltip';

type Props = {
  tooltip: React.ReactNode | React.ReactNodeArray | string;
  placement?: PopperOptions['placement'];
  modifiers?: PopperOptions['modifiers'];
  offset?: Config['offset'];
  show?: boolean;
  children: React.ReactNode | React.ReactNodeArray | string;
};

const Tooltip = ({
  tooltip,
  placement = 'top',
  modifiers,
  offset,
  show = true,
  children,
}: Props) => {
  const [controlledVisible, setControlledVisible] = useState(false);
  const {
    getTooltipProps,
    getArrowProps,
    setTriggerRef,
    setTooltipRef,
    visible,
  } = usePopperTooltip(
    {
      trigger: 'hover',
      placement,
      offset,
      closeOnOutsideClick: false,
      visible: controlledVisible,
      onVisibleChange: setControlledVisible,
    },
    { modifiers },
  );

  return (
    <>
      {show && !!tooltip ? (
        <span ref={setTriggerRef}>
          {children ?? <FaInfo className="info-icon" />}
          {visible && (
            <div
              ref={setTooltipRef}
              {...getTooltipProps({ className: 'tooltip-container' })}
            >
              <div {...getArrowProps({ className: 'tooltip-arrow' })} />
              {tooltip}
            </div>
          )}
        </span>
      ) : (
        children
      )}
    </>
  );
};

export default Tooltip;
